import { UserProfile } from '../components/UserProfile';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { getProfileUser } from 'lib/api/users';
export const UserProfilePage = () => {
    const [profile, setProfile] = useState({});

    useEffect(() => {
        let isMounted = true;
        getProfileUser()
            .then(response => {
                if (!isMounted) return;
                setProfile(response);
            })
            .catch(() => {
                if (!isMounted) return;
                setProfile({});
            });
        return () => (isMounted = false);
    }, []);

    return (
        <Box>
            <Box
                sx={{
                    marginBottom: '20px'
                }}>
                <label
                    style={{
                        fontWeight: 'bold',
                        fontSize: '30px',
                        lineHeight: '37px',
                        color: '#182D55'
                    }}>
                    Edit Profile
                </label>
            </Box>
            <UserProfile profileUser={profile} />
        </Box>
    );
};
